export default "__VITE_ASSET__e75e3208__"